import { Box } from '@locus-taxy/encore-mui';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import DashboardToolbarActions from './DashboardToolbarActions';
import { buildClientPrefixedPath } from '../../utils/url';
import { useClientId } from '../../hooks/useClientId';
import Logo from '../../assets/Logo.svg?url';
import { getTestId } from '@locus-taxy/encore-utils';

export default function AppTitleWithActions() {
  const clientId = useClientId();
  const { t } = useTranslation();
  const homeHref = buildClientPrefixedPath('/', clientId);
  const logoNode = (
    <Box
      component="img"
      src={Logo}
      alt={t('sidebar.encoreLogoAlt')}
      sx={{ height: 20, verticalAlign: 'middle' }}
      data-testid={getTestId({
        action: 'view',
        object: 'image',
        entity: 'locus-logo',
        page: 'page-header',
      })}
    />
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <RouterLink to={homeHref}>
        {/* Prefer logo; fallback to title if no logo provided */}
        {logoNode}
      </RouterLink>
      <DashboardToolbarActions />
    </Box>
  );
}
